import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import MemberCard from "../components/MemberCard";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { NbButton } from "../components/nb";
import { Heart, Crown, Lock } from "lucide-react";

export default function Matches() {
  const { user } = useAuth();
  const [matches, setMatches] = useState([]);
  const [likers, setLikers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [likersLocked, setLikersLocked] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const m = await api.get("/matches");
        setMatches(m.data);
        try {
          const l = await api.get("/likes/received");
          setLikers(l.data);
        } catch (e) {
          if (e.response?.status === 402) setLikersLocked(true);
        }
      } catch {} finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="min-h-screen grain">
      <Navbar />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        <h1 className="font-head font-black text-4xl tracking-tighter mb-1 flex items-center gap-2"><Heart className="w-8 h-8 text-[#8B1E3F]" fill="#8B1E3F" /> Matches</h1>
        <p className="text-gray-600 font-medium mb-8">People you both liked. Start a conversation!</p>

        {loading ? <div className="text-center py-20 font-head font-bold uppercase">Loading...</div> : (
          <>
            {matches.length === 0 ? (
              <div className="bg-white nb-border nb-shadow p-10 text-center font-medium mb-10">No matches yet. Keep browsing and liking!</div>
            ) : (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mb-12">
                {matches.map((m) => (
                  <div key={m.id} className="relative">
                    <MemberCard m={{ ...m, liked: true }} />
                    <Link to={`/messages/${m.id}`} data-testid={`message-match-${m.id}`} className="block mt-2"><NbButton variant="secondary" className="w-full text-xs py-2">Message</NbButton></Link>
                  </div>
                ))}
              </div>
            )}

            <h2 className="font-head font-black text-2xl tracking-tight mb-4 flex items-center gap-2"><Crown className="w-6 h-6" /> Who Likes You</h2>
            {likersLocked ? (
              <div className="bg-[#F3E8E6] nb-border nb-shadow p-8 text-center">
                <Lock className="w-8 h-8 mx-auto mb-3" />
                <p className="font-head font-bold text-lg mb-4">Upgrade to Premium to see everyone who likes you.</p>
                <NbButton as={Link} to="/upgrade" variant="dark" data-testid="matches-upgrade">Go Premium</NbButton>
              </div>
            ) : likers.length === 0 ? (
              <div className="bg-white nb-border nb-shadow p-8 text-center font-medium">No one has liked you yet — share your QR more!</div>
            ) : (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
                {likers.map((m) => <MemberCard key={m.id} m={m} />)}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
